import { createAction, props } from '@ngrx/store';
import { SearchResult } from '../../models';

export const LoadSearchResults = createAction('[Search] Load Search Results', props<{ q: string }>());
export const LoadSearchResultsSuccess = createAction('[Search] Load Search Results Success', props<{ results: SearchResult[] }>());
export const LoadSearchResultsFail = createAction('[Search] Load Search Results Fail', props<{ error: any }>());
